import { createStyles } from "@mantine/emotion";

import { getBarHeight }     from "_common/utils";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	const barHeight = getBarHeight ();

	return {
		emptyFanRankViewContainer: {
			display        : "flex",
			justifyContent : "center",
			alignItems     : "center",
			height         : "90%",
			textAlign      : "center",
			position       : "relative",

			[rooterMediaQuery.mobileAndTablet]: {
				height     : `calc((100vh - 56.25vw) - 120px - ${ barHeight }px )`,
				background : theme.other.colors.dialog.secondary
			}
		},
		icon: {
			height       : "12rem",
			width        : "12rem",
			marginBottom : "1rem"
		},
		emptyFanrankMessage: {
			padding: "0 10%"
		}
	};
} );

